import WMTS from "ol/source/WMTS";
import TileLayer from "ol/layer/Tile";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";

const projExtent = [274000, 3087000, 3327000, 7173000];
export const resolutions = [8960, 4480, 2240, 1120, 560, 280, 140, 70, 28, 14, 7, 2.8/*, 1.4, 0.7, 0.28, 0.14, 0.07*/];
const matrixIds = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"/*, "12", "13", "14", "15", "16"*/];
const tileGrid = new WMTSTileGrid({
    // origin: getTopLeft(projExtent),
    extent: projExtent,
    resolutions,
    matrixIds
});

/**
 *
 * @param hdpi
 * @param mapLayersURL
 * @param layerName
 * @param attribution
 * @returns {TileLayer}
 */
export function wmtsLayer({hdpi, mapLayersURL, layerName}) {
    const matrixSet = hdpi ? "NZTM2000HDPI" : "NZTM2000";

    const source = new WMTS({
        tileGrid,
        crossOrigin: 'anonymous',
        projection: "EPSG:2193",
        url: mapLayersURL,
        format: 'jpeng',
        layer: layerName + (hdpi ? '-HDPI' : ''),
        style: 'default',
        tilePixelRatio: hdpi ? 2 : 1,
        matrixSet
    });

    return new TileLayer({ source })
}

/**
 * convert a domain of the form sub-domain-{1-4}.domain.com to sub-domain-1.domain.com
 * @param {string} url
 */
function cleanDomainForWMS(url) {
    return url.replace(/{(\d+)-\d+}/, '$1');
}


/**
 *
 * @param extraParams
 * @param hdpi
 * @param url
 * @param map
 * @param layers
 * @returns {ImageLayer}
 */
export function mapUnitWMSLayer({extraParams, hdpi, url, map, layers}) {
    const source = new ImageWMS({
        params: {
            SERVICE: 'WMS',
            VERSION: '1.1.1',
            FORMAT: 'image/png',
            TRANSPARENT: 'true',
            LAYERS: layers,
            SRS: 'EPSG:2193',
            STYLES: '',
            map,
            ...extraParams
        },
        url: cleanDomainForWMS(url),
        crossOrigin: 'anonymous',
        hidpi: hdpi,
        serverType: 'mapserver'
    });

    return new ImageLayer({ source });
}
